// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: "#0071db",
      dark: "#0641aa",
      light: "#0092fd",
      contrastText: "#fff"
    },
    secondary: {
      main: "#6a00db",
      dark: "#4900cd",
      light: "#a268eb",
      contrastText: "#fff"
    },
    error: {
      main: "#db0071",
      dark: "#89035c",
      light: "#ef60a2",
      contrastText: "#fff"
    },
    warning: {
      main: "#db6a00",
      dark: "#d15200",
      light: "#eb9307",
      contrastText: "#fff",
    },
    info: {
      main: "#0004db",
      dark: "#0000d5",
      light: "#7947f2",
      contrastText: "#fff"
    },
    success: {
      main: "#00bab2",
      dark: "#009d91",
      light: "#00dbd7",
      contrastText: "#fff"
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

export default theme;
